package appConfig

import com.friendly.framework.graph.AppType
import common.constants.KeyConstant
import common.constants.UserDefaults
import feature.auth.model.BusinessConstants
import feature.business.handler.BusinessHandler
import feature.business.model.Business
import feature.mediaFile.viewModel.MediaFileViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import theme.ThemeColor

class AppConfig {
    val scope = CoroutineScope(Job() + Dispatchers.Default)
    val appName = "Solute"
    val countryCode = "IN"
    var currency = "Euro"
    var currencySymbol = "€"
    var business: Business? = null
    var appType = AppType.BUSINESS

    init {
        instance = this
    }

    companion object {
        private var instance: AppConfig? = null
        fun shared(): AppConfig {
            if (instance != null) {
                return instance as AppConfig
            } else {
                return AppConfig()
            }
        }
    }

    fun setBusiness() {
        if (appType != AppType.BUSINESS && BusinessConstants().selectedBusiness.isNotBlank()) {
            business = Json.decodeFromString(BusinessConstants().selectedBusiness)
            scope.launch {
                BusinessHandler.shared().repository.businessLiveData.emit(business!!)
            }
            ThemeColor.shared().applyCustomTheme()
            MediaFileViewModel().retrieve()
        } else {
            val selectedBusiness = UserDefaults.retrieve(KeyConstant.selectedBusiness)
            if (selectedBusiness.isNotEmpty()) {
                business = Json.decodeFromString(selectedBusiness)
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    BusinessHandler.shared().repository.businessLiveData.emit(business!!)
                }
            }
        }
    }
}